import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "notices" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { class: "notices-message-close" }, "×", -1)
const _hoisted_4 = {
  key: 0,
  class: "disconnected"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "disconnected-message" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Connection Error"),
  /*#__PURE__*/_createElementVNode("p", null, "Unable to connect to the server. Please try again.")
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "ul",
        class: "notices-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notices, (notice) => {
            return (_openBlock(), _createElementBlock("li", {
              key: notice.id,
              class: _normalizeClass(["notices-message", [`notices-message-${notice.type}`]]),
              onClick: ($event: any) => (_ctx.dismissNotice(notice.id))
            }, [
              _hoisted_3,
              _createElementVNode("h3", null, _toDisplayString(notice.title), 1),
              _createElementVNode("p", null, _toDisplayString(notice.message), 1)
            ], 10, _hoisted_2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.connectionError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}